import { Dollar } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconDollar12Line = createIcon(Dollar, 12, "Line");
export const IconDollar16Line = createIcon(Dollar, 16, "Line");
export const IconDollar20Line = createIcon(Dollar, 20, "Line");
export const IconDollar24Line = createIcon(Dollar, 24, "Line");
export const IconDollar32Line = createIcon(Dollar, 32, "Line");
export const IconDollar48Line = createIcon(Dollar, 48, "Line");
export const IconDollar64Line = createIcon(Dollar, 64, "Line");
